import HorizontalLogoIcon from './Horizontal.svg?react';
import mohaIcon from './Icon.png';

interface LogoProps {
    size: 'small' | 'medium' | 'large';
}
const RoundedLogo = ({ size }: LogoProps) => {
    const sizeInPx = {
        small: 'w-[108px] h-[108px]',
        medium: 'w-[216px] h-[216px]',
        large: 'w-[432px] h-[432px]',
    };

    return (
        <svg
            width="108"
            height="108"
            viewBox="0 0 108 108"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={sizeInPx[size]}
        >
            <rect
                x="0.5"
                y="0.5"
                width="107"
                height="107"
                rx="53.5"
                className="fill-neutral-50 dark:fill-neutral-50-dark"
            />
            <g clip-path="url(#clip0_39_837)">
                <path
                    d="M35.0858 40.5137C39.8417 40.4471 43.5117 42.4455 46.2855 46.2276C50.0675 51.385 53.8916 56.5121 57.6914 61.6568C59.1199 63.5907 59.1747 64.6454 57.964 66.2439C56.7787 67.809 54.1501 67.9605 52.9304 66.4236C50.9747 63.9594 49.1285 61.4096 47.2219 58.9066C44.7928 55.7181 42.3892 52.5089 39.8986 49.3684C38.2548 47.2958 35.9701 46.8326 33.4943 47.4164C31.1968 47.9581 29.7615 49.4832 28.8946 51.666C27.8686 54.2508 29.1731 57.4895 31.1875 58.9712C33.4595 60.6422 36.6247 60.6751 39.0075 59.0619C40.1732 58.2725 40.9 57.1402 41.3997 55.8742C41.6663 55.1988 41.8662 55.0692 42.3255 55.705C43.3588 57.1347 44.3806 58.5746 45.4661 59.9647C46.0006 60.6494 46.0095 61.2122 45.4908 61.8956C42.6919 65.5836 39.0181 67.4331 34.3276 67.2041C26.6791 66.8294 21.2147 59.9495 22.0926 52.0258C22.6869 46.6617 27.4071 41.7106 31.9754 40.8103C33.0014 40.6082 34.0338 40.4525 35.0858 40.5137Z"
                    fill="url(#paint0_linear_39_837)"
                />
                <path
                    d="M66.1593 52.5277C64.8985 50.8052 63.6151 49.0645 62.3496 47.3112C62.1276 47.0037 62.3471 46.7214 62.5284 46.4624C64.7766 43.2562 67.7873 41.2805 71.7684 40.9654C77.5347 40.5085 81.7918 42.9431 84.4518 47.9322C87.7635 54.1439 85.601 61.9292 79.5027 65.6016C73.8681 68.9948 66.0438 67.4034 61.9014 61.6499C58.163 56.4579 54.3211 51.3393 50.537 46.1793C49.17 44.3155 49.1123 43.3583 50.1991 41.8707C51.3236 40.3313 54.0588 40.2191 55.2135 41.7353C58.7353 46.3591 62.2138 51.0149 65.714 55.6551C66.4017 56.5667 67.0953 57.4742 67.8081 58.366C70.2287 61.3955 74.4174 61.8288 77.2214 59.3494C80.3098 56.6186 80.5195 52.3509 77.7036 49.5493C74.2082 46.0718 68.4351 47.2652 66.6144 51.8384C66.5295 52.0518 66.5694 52.3341 66.1593 52.5281V52.5277Z"
                    fill="url(#paint1_linear_39_837)"
                />
            </g>
            <rect
                x="0.5"
                y="0.5"
                width="107"
                height="107"
                rx="53.5"
                className="stroke-neutral-100 dark:stroke-neutral-100-dark"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_39_837"
                    x1="58.8212"
                    y1="40.5002"
                    x2="19.3219"
                    y2="45.2558"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#FBB931" />
                    <stop offset="1" stop-color="#FF8660" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_39_837"
                    x1="85.9999"
                    y1="40.6553"
                    x2="46.7869"
                    y2="45.393"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#FBB931" />
                    <stop offset="1" stop-color="#FF8660" />
                </linearGradient>
                <clipPath id="clip0_39_837">
                    <rect
                        width="64"
                        height="27"
                        fill="white"
                        transform="translate(22 40.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

const HorizontalLogo = ({ size }: LogoProps) => {
    const sizeInPx = {
        small: 'w-[216px] h-[16px]',
        medium: 'w-[272px] h-[24px]',
        large: 'w-[1066px] h-[96px]',
    };
    //later refactor to include Black
    return <HorizontalLogoIcon className={sizeInPx[size]} />;
};

const MohaIcon = ({ size }: LogoProps) => {
    const sizeInPx = {
        small: 'w-[42px] h-[18px] ',
        medium: 'w-[56px] h-[24px] ',
        large: 'w-[256px] h-[106px] ',
    };
    //later refactor to include Black
    return (
        <div className={sizeInPx[size]}>
            <img src={mohaIcon} alt={'More Harvest'} />
        </div>
    );
};

export { HorizontalLogo, MohaIcon, RoundedLogo };
